import { HelperProps } from './TourNavigator_/types'

export default function TourHelperTwo({currentStep, steps, currentStepIndex, previousStepIndex, isScrollingIntoView, goto, next, prev}: HelperProps) {

    if(isScrollingIntoView){
        currentStep = steps[previousStepIndex]
        currentStepIndex = previousStepIndex
    }

    const isFirst = currentStepIndex == 0
    const isLast = currentStepIndex == steps.length-1


    return (
    <div style={{width: 150, background: 'white', padding: 10, borderRadius: 5}}>
        <h4 style={{padding: 0, margin: 0}}>{currentStep?.data.title}</h4>
        <small style={{padding: 0, margin: 0}}>{currentStep?.data.description}</small>
        
        <div style={{display: 'flex', gap: 10, marginTop: 10}}>
            <div onClick={prev} style={{height: 30, width: 30, borderRadius: 15, cursor: 'pointer', background: isFirst ? 'lightgray':'teal', scale: '-1', display: 'grid', justifyContent: 'center', alignItems: 'center'}}>
                <svg width="20px" height="20px" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.71069 18.2929C10.1012 18.6834 10.7344 18.6834 11.1249 18.2929L16.0123 13.4006C16.7927 12.6195 16.7924 11.3537 16.0117 10.5729L11.1213 5.68254C10.7308 5.29202 10.0976 5.29202 9.70708 5.68254C9.31655 6.07307 9.31655 6.70623 9.70708 7.09676L13.8927 11.2824C14.2833 11.6729 14.2833 12.3061 13.8927 12.6966L9.71069 16.8787C9.32016 17.2692 9.32016 17.9023 9.71069 18.2929Z" fill="white"/>
                </svg>
            </div>
            <div style={{display: 'flex', gap: 5, marginTop: 10}}>
            {
                steps.map((step, index) => {
                    return <div key={index} onClick={() => goto(index)} style={{height: 5, width: 5, borderRadius: 5, background:  index <= currentStepIndex ? 'teal':'lightgray'}}/>
                })
            }
        </div>
            <div onClick={next} style={{height: 30, width: 30, borderRadius: 15, cursor: 'pointer', background: isLast ? 'lightgray':'teal', display: 'grid', justifyContent: 'center', alignItems: 'center'}}>
                <svg width="20px" height="20px" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.71069 18.2929C10.1012 18.6834 10.7344 18.6834 11.1249 18.2929L16.0123 13.4006C16.7927 12.6195 16.7924 11.3537 16.0117 10.5729L11.1213 5.68254C10.7308 5.29202 10.0976 5.29202 9.70708 5.68254C9.31655 6.07307 9.31655 6.70623 9.70708 7.09676L13.8927 11.2824C14.2833 11.6729 14.2833 12.3061 13.8927 12.6966L9.71069 16.8787C9.32016 17.2692 9.32016 17.9023 9.71069 18.2929Z" fill="white"/>
                </svg>
            </div>
        </div>
        <div style={{position: 'absolute', top: 10, right: 10, fontSize: 10, color: '#adadad'}}>{currentStepIndex+1}/{steps.length}</div>
    </div>
  )
}
